import type { MouseEvent } from 'react';

import { posthogCapture } from '@/shared/vendor/posthog';

import classnames from 'classnames';

type ActionType = 'green' | 'red' | 'gray';

const EVENT_MAP: Record<ActionType, string> = {
  green: 'alert_bell.approve',
  red: 'alert_bell.deny',
  gray: 'alert_bell.dismiss',
};

interface ActionProps {
  title: string;
  type: ActionType;
  icon?: string;
  click?: (e: MouseEvent<HTMLButtonElement>) => void;
  requestType?: string;
}

export default function ActionButton({ click, type, icon, title, requestType }: ActionProps) {
  const actionAttributes = () => {
    if (click) {
      return { onClick: click };
    }
  };

  const stopClickFocus = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const event = EVENT_MAP[type];
    if (event) {
      posthogCapture(event, {
        'request type': requestType,
      });
    }
  };

  return (
    <button
      type="button"
      onMouseDown={stopClickFocus}
      className={classnames('btn', 'action-button', type)}
      data-testid="alert-bell"
      {...actionAttributes()}
    >
      {icon && <i className={`fa ${icon}`} />}
      {title}
    </button>
  );
}
